export class FrontendFuncParam {
	Name:string = "nieuweParamater";

	public constructor(data?:any) {
		if (!data) return;
		this.Name = data.Name;
	}

}